import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/tools/page-client.tsx");
